import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { fetchApps } from '../store/actions/appAction'
import { findUser } from '../store/actions/userAction'
import AppCard from '../components/AppCard'
import Menubar from '../components/Menubar';

import { Container, Typography, Grid, Card, CardContent, Box } from '@material-ui/core';
import { MdAdd } from "react-icons/md";
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom'
const facebookAppId = '463821918300789'; 

const useStyles = makeStyles((theme) => ({
  containerTop: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "-2rem",
      marginBottom: "-4rem",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "0",
    },
  },
  contentDashboard : {
    paddingTop: "5%",
    paddingLeft: "20%",
    backgroundColor: "#e8e8e8",
    paddingRight: "2%",
    paddingBottom: "14%",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "30%",
      paddingLeft: "0",
      paddingRight: "0"
    },
  },
  contentAccount : {
    justifyContent: "space-between",
    display: "flex",
    alignSelf: "center",
    color: "rgb(170, 170, 170) !important",
    fontSize: "14px",
    fontWeight: "500",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      flexDirection: "column",  
    },
  },
  newAppCard: {
    cursor: "pointer", 
    height: "100%", 
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "10px",
    boxShadow: "rgb(0 0 0 / 15%) 0px 5px 5px 0px"
  },
  boxUser: {
    padding: "30px 45px",
    [theme.breakpoints.down("sm")]: {
      padding: "15px",
    },
  },
  boxContainerUser: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",  
    },
  }
}));


const Dashboard = () => {
  const classes = useStyles();
  const dispatch = useDispatch()
  const history = useHistory()
  
  useEffect(() => {
    window.scrollTo(0, 0)
    window.fbAsyncInit = function() {
      window.FB.init({
              appId      : facebookAppId,
              cookie     : false,
              xfbml      : true,
              version    : 'v10.0',
          });        
      };

      (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/id_ID/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

    dispatch(fetchApps())
  }, [dispatch])
  
  useEffect(() => {
    dispatch(findUser())
  }, [])

  const user = useSelector(state => state.userReducer.userLogin)
  const packages = useSelector(state => state.userReducer.package)
  const subs = useSelector(state => state.userReducer.subs)
  const apps = useSelector(state => state.appReducer.apps)

  const handleNewApp = () => {
    history.push('/createApp')
  }

  return (
    <>
      <div>
          <Grid className={classes.containerTop} container direction="row" alignItems="center">
            <Menubar/>
            <Grid item xs={12} md={12} className={classes.contentDashboard}>
            <div style={{ width: '100%', padding: "20px" }}>
              <Box 
              display="flex" 
              flexDirection="row" 
              px={6} 
              py={4} 
              bgcolor="background.paper" 
              style={{borderRadius: "10px", boxShadow: "0px 5px 5px 0px hsl(0deg 0% 0% / 15%)"}}
              className={classes.boxUser}>
                <Grid container className={classes.boxContainerUser}>
                  <Grid item xs={12} md={2} >
                    {
                      user.profileImageUrl?
                      <img style={{borderRadius: "50%", width: "100px", height: "100px", objectFit: "cover"}} width="150px" src={user.profileImageUrl} alt="logo quickey beta"/>
                      :
                      <img style={{borderRadius: "50%", width: "100px", height: "100px", objectFit: "cover"}} width="150px" src="/person-dummy.png" alt="logo quickey beta"/>
                    }
                  </Grid>
                  <Grid item xs={12} md={8} >
                    <h5>Hallo, {user.name? user.name : user.email ? user.email : user.phone}</h5>
                    <Box display="flex" justifyContent="space-between" className={classes.contentAccount}> 
                      <div>
                        <p className="mb-1">Akun {packages.name}</p>
                      </div>
                      <div>
                        {
                          user?.email ?
                          <p className="mb-1">Email :&emsp;
                            <span>{user.email}</span>
                          </p>
                          :
                          <p className="mb-1">Phone Number :&emsp;
                            <span>{user.phone}</span>
                          </p>
                        }
                        {/* <p className="mb-1">Kuota :&emsp;
                          <span>{packages.otpLimit?.whatsapp}</span>
                        </p> */}
                        <p className="mb-1">Saldo :&emsp;
                          {
                            subs?.balance?
                            <span>Rp. {Number(subs.balance).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"}</span>
                            :
                            <span>-</span>                            
                          }
                        </p>
                      </div>
                      <div>
                        <p className="mb-1">Jumlah Apps :&emsp;
                          <span>{user?.apps?.length !== 0 ? user?.apps?.length: "-"}</span>
                        </p>
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </div>
              <Typography align="center" color="textPrimary" spacing={4} gutterBottom className="mt-30 reguler font-size-28">
                Aplikasi Terdaftar
              </Typography>
                <Grid container align="center">
                      {
                          apps.map(app => {
                              return (
                                  <Grid item key={app._id} xs={12} md={4} style={{padding: "20px"}}>
                                      <AppCard app={app}/>
                                  </Grid>
                              )
                          })
                      }
                      <Grid item xs={12} md={4} style={{padding: "20px"}}>
                        <Card variant="outlined" className={classes.newAppCard} onClick={() => handleNewApp()}>
                          <CardContent>
                            <MdAdd className="font-size-36"/>
                            <Typography color="textSecondary" gutterBottom className="reguler font-size-18 mt-5">
                              New app
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                  </Grid>
            </Grid>
          </Grid>
      </div>
    </>
  );
}

export default Dashboard;
